import styled from "styled-components";
import {Button} from "../../../../../basic-ui-components/button/base/button.component";

export const OptInDialogFooterButtonBox = styled(Button)`
    width: 100%;

    &:nth-of-type(1) {
        @media ${({theme}) => `${theme.mediaQuery.xlAndAbove} or ${theme.mediaQuery.landscape}`} {
            margin-right: 12px;
            margin-bottom: 0px;
        }           
        margin-bottom: 12px;
    }

    &:nth-of-type(2) {
        background:${props => props.theme.colors.backgroundMiddleDark};
    }
`